export const getElementText = (element: any): string => {
  if (['string', 'number'].includes(typeof element)) return `${element}`.trim();
  if (element instanceof Array) return element.map(getElementText).join(' ').trim();
  if (typeof element === 'object' && element) return getElementText(element.props?.children ?? []).trim();
  return '';
};

export const isFeatureEnabled = (featureFlag: string): boolean => {
  const featureFlags: string[] = window.ciq?.enabledFeatureFlags || [];
  return featureFlags.includes(featureFlag);
};
